// @ts-strict-ignore
import React, { FC } from 'react'
import { useLiveQuery } from 'dexie-react-hooks'
import db from 'mobile_web/modules/db'
import { ManifestBadgeGroups } from 'mytours-read-api-typescript'
import { Language } from 'mytours-read-common'
import { getDirMode } from '../../platform'
import { IonGrid, IonRow } from '@ionic/react'
import { BadgeGroup } from '@mytours/components'
import { listedBadges, toBadgeItem, useEarnedBadgeIds, useOpenBadge } from '../badgeItems'

interface BadgeGroupBlockProps {
	group: ManifestBadgeGroups
	currentLanguage?: Language
}

const BadgeGroupBlock: FC<BadgeGroupBlockProps> = ({ group }) => {
	const badgeGroup = useLiveQuery(() => db.badgeGroups.get({ id: group?.id }), [group])
	const badges = useLiveQuery(() => db.badges.where({ group_id: group.id }).toArray(), [group]) || []
	const earnedIds = useEarnedBadgeIds() ?? new Set<number>()
	const openBadge = useOpenBadge()

	const items = listedBadges(badges, earnedIds).map(badge => {
		const earned = earnedIds.has(badge.id)
		return toBadgeItem(badge, earned, () => openBadge(badge, earned))
	})

	return badges.length > 0 ? (
		<IonGrid dir={getDirMode()} className="block badge-group-block">
			<IonRow dir={getDirMode()} className="block-header">
				<h2 className="subheading">{badgeGroup?.title}</h2>
			</IonRow>
			<BadgeGroup className="block-content" dir={getDirMode()} items={items} />
		</IonGrid>
	) : null
}

export default BadgeGroupBlock
